import classes from "./TabsComponent.module.css";

function TabsComponent({
  data,
  value,
  onClick,
  containerClass,
  count,
  variant = "primary",
}) {
  return (
    <div
      className={[classes._tabsHeading, containerClass && containerClass].join(
        " "
      )}
    >
      {data?.map((ele, index) => (
        <div
          className={[
            classes._initialTab,
            value?.value === ele?.value && classes._active,
          ].join(" ")}
          onClick={() => onClick(ele)}
          key={index}
          data-variant={variant}
        >
          <p>{ele?.label}</p>
        </div>
      ))}
    </div>
  );
}

export default TabsComponent;
